var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31589 0.423343C7.59047 -0.141116 8.40953 -0.141113 8.68411 0.423343L10.6998 4.56712L15.3402 5.16716C15.9723 5.24889 16.2254 6.01304 15.763 6.44363L12.3684 9.60466L13.2206 14.1193C13.3367 14.7342 12.674 15.2065 12.1137 14.9082L8 12.718L3.88632 14.9082C3.32596 15.2065 2.66332 14.7342 2.77941 14.1193L3.63161 9.60466L0.237013 6.44363C-0.225394 6.01303 0.0277149 5.24889 0.659817 5.16716L5.30019 4.56712L7.31589 0.423343ZM8 1.60686L6.23776 5.22957C6.12726 5.45673 5.90711 5.61364 5.65272 5.64653L1.59586 6.17112L4.5636 8.93466C4.74969 9.10795 4.83378 9.36183 4.78706 9.60932L4.04202 13.5562L7.63842 11.6415C7.86394 11.5214 8.13606 11.5214 8.36158 11.6415L11.958 13.5562L11.2129 9.60932C11.1662 9.36183 11.2503 9.10795 11.4364 8.93466L14.4041 6.17112L10.3473 5.64653C10.0929 5.61364 9.87274 5.45673 9.76223 5.22957L8 1.60686Z",
    fill: "#A5B1C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.27a6edb7c437c8ab0b9bcfa8a9e064e1.svg";
export { ForwardRef as ReactComponent };